import React from 'react';
import PropTypes from 'prop-types';

function PhoneInput({ countryCode = '+91' }) {
  return (
    <div
      className="flex shrink-0 items-center gap-2 h-[52px] rounded-xl bg-zinc-800/90 px-3 sm:px-4"
      aria-hidden
    >
      <span className="text-xl leading-none" role="img" aria-label="India">
        🇮🇳
      </span>
      <span className="text-sm font-semibold text-white/90 tabular-nums">{countryCode}</span>
    </div>
  );
}

PhoneInput.propTypes = {
  countryCode: PropTypes.string,
};

export default PhoneInput;
